var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkpapersLogoIndigo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32V19.9953C0 17.6622 1.16661 15.4724 3.1276 14.1219L9.59841 9.6716C9.99106 9.40062 10.2248 8.96441 10.2248 8.49515V0H20.4474V1.74926C20.4474 3.00282 19.821 4.17928 18.7656 4.9041L10.681 10.4647C10.3928 10.663 10.2226 10.9824 10.2226 11.3261V32.0022H0V32ZM21.7752 32V23.6833C21.7752 23.2162 22.0089 22.7778 22.4016 22.5069L28.8724 18.0566C30.8357 16.7083 32 14.5184 32 12.1831V0H21.7774V20.8589C21.7774 21.2004 21.6072 21.5221 21.319 21.7203L13.2344 27.281C12.179 28.0058 11.5526 29.1822 11.5526 30.4358V32.0022H21.7752V32Z",
    fill: "#7B70FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkpapersLogoIndigo);
export default __webpack_public_path__ + "static/media/workpapers-logo-indigo.5a899700d99e826dba2ab8cf8e10f40c.svg";
export { ForwardRef as ReactComponent };